import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const WhatsAppChat = () => {
  const [open, setOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);

  // Campos del formulario
  const [fullName, setFullName] = useState("");
  const [question, setQuestion] = useState("");
  const [userNumber, setUserNumber] = useState("");

  const myWhatsApp = "5217757067677"; // <-- TU NÚMERO

  const sendToServer = async () => {
    if (!fullName || !question || !userNumber) {
      alert("Por favor completa todos los campos.");
      return;
    }

    const data = {
      nombre: fullName,
      telefono: userNumber,
      duda: question,
      tipo: "Duda General",
    };

    try {
      const res = await fetch("http://localhost:4000/send-message", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await res.json();

      if (result.success) {
        alert("Mensaje enviado correctamente 🎉");
        setFullName("");
        setQuestion("");
        setUserNumber("");
        setShowForm(false);
      } else {
        alert("Hubo un error al enviar la duda");
      }
    } catch (error) {
      console.log(error);
      alert("Error al conectar con el servidor");
    }
  };

  return (
    <>
      {/* Botón principal flotante */}
      <motion.button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <FaWhatsapp size={28} />
      </motion.button>

      {/* Ventana emergente */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.25 }}
            className="fixed bottom-20 right-6 w-80 bg-white rounded-xl shadow-xl border border-gray-300 z-50 overflow-hidden"
          >
            <div className="bg-green-600 text-white p-3 font-semibold flex justify-between items-center">
              <span>¿Cómo deseas contactarnos?</span>
              <button
                onClick={() => setOpen(false)}
                className="text-white text-lg"
              >
                ✕
              </button>
            </div>

            {/* Opciones */}
            {!showForm && (
              <div className="p-4 flex flex-col gap-3">
                <button
                  onClick={() => setShowForm(true)}
                  className="p-3 bg-green-100 border border-green-300 rounded-lg text-left font-medium hover:bg-green-200"
                >
                  📩 Duda general
                </button>

                <button
                  onClick={() =>
                    window.open(`https://wa.me/${myWhatsApp}`, "_blank")
                  }
                  className="p-3 bg-green-500 text-white rounded-lg font-medium hover:bg-green-600"
                >
                  💬 Escríbenos directamente
                </button>
              </div>
            )}

            {/* Formulario de duda general */}
            {showForm && (
              <div className="p-4 flex flex-col gap-3">
                <input
                  type="text"
                  placeholder="Nombre completo"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="border p-2 rounded"
                />

                <textarea
                  placeholder="Describe tu duda"
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  className="border p-2 rounded h-20 resize-none"
                />

                <input
                  type="text"
                  placeholder="Tu número de WhatsApp"
                  value={userNumber}
                  onChange={(e) => setUserNumber(e.target.value)}
                  className="border p-2 rounded"
                />

                <button
                  onClick={sendToServer}
                  className="bg-green-500 hover:bg-green-600 text-white p-2 rounded font-semibold"
                >
                  Enviar duda
                </button>

                <button
                  onClick={() => setShowForm(false)}
                  className="text-sm text-gray-600 underline"
                >
                  ← Volver atrás
                </button>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default WhatsAppChat;
